import $http from './http'
import config from './config'
export default {
    name: 'charge',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    OrderDetails(UniqueID) {
        return $http.get(this.getUrl(`/ChargeOrder/OrderDetails?UniqueID=${UniqueID}`));
    },
    getOrderList(data) {
        return $http.post(this.getUrl('/ChargeOrder/List'), data);
    },
    OrderResolve(data) {
        return $http.post(this.getUrl(`/ChargeOrder/OrderResolve`), data);
    },
    OrderUnLock(id){
        return $http.get(this.getUrl(`/ChargeOrder/OrderUnLock?UniqueID=${id}`));
    },
    UpdateOrderPrice(data){
        return $http.post(this.getUrl('/ChargeOrder/UpdateOrderPrice'),data);
    }
}


// WEBPACK FOOTER //
// ./src/apis/chargeapi.js